import { render } from "./about-grid-images.vue?vue&type=template&id=676dff03"
import script from "./about-grid-images.vue?vue&type=script&lang=js"
export * from "./about-grid-images.vue?vue&type=script&lang=js"

import "./about-grid-images.vue?vue&type=style&index=0&id=676dff03&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__